// extracted by mini-css-extract-plugin
export default {"double__img":"doubleImg-module--double__img--1sHez","img":"doubleImg-module--img--3NqbZ"};